import {
  decodeProjectId,
  decodeWorkspaceId,
  encodeProjectId,
  encodeWorkspaceId,
} from "@papersflow/contracts";
import type { Id } from "../../../backend/convex/_generated/dataModel";

export function parseProjectSettingsRouteParams(params: {
  readonly projectId: string;
  readonly workspaceId: string;
}): { readonly projectId: Id<"projects">; readonly workspaceId: Id<"workspaces"> } | false {
  try {
    const workspaceId = encodeWorkspaceId(decodeWorkspaceId(params.workspaceId));
    const projectId = encodeProjectId(decodeProjectId(params.projectId));
    return {
      // @ts-expect-error -- Canonical contract values adapt here to Convex's compile-time table brand.
      workspaceId,
      // @ts-expect-error -- Canonical contract values adapt here to Convex's compile-time table brand.
      projectId,
    };
  } catch {
    return false;
  }
}
